import { Box, styled } from '@mui/material';
import { palette } from 'view/themes/palette';

export const FormWrapperMainSeparator = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  textAlign: 'center',
  width: '100%',
  position: 'relative',

  '&::before, &::after': {
    content: '" "',
    flex: 1,
    borderBottom: `1px solid ${palette.border.default}`,
  },

  '&::before': {
    marginRight: '10px',
  },

  '&::after': {
    marginLeft: '10px',
  },

  '> span': {
    display: 'inline-block',
    padding: '0 10px',
    background: palette.white,
    color: palette.text.body,
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
  },
}) as typeof Box;
